// 🛡️ SECURITY: Performance monitoring with dependency integrity
const safeReportError = async (message, context = {}) => {
  try {
    if (process.env.NODE_ENV !== 'production') return;
    const payload = {
      message: String(message || 'unknown_error'),
      context: { location: window?.location?.pathname || '/', ...context },
      ts: Date.now(),
    };
    await fetch('/api/client-logs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (_) {}
};

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // Security: Add version pinning and integrity checks
    const webVitalsVersion = process.env.REACT_APP_WEB_VITALS_VERSION || '^3.0.0';
    
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Security: Validate that all required functions are available
      if (typeof getCLS === 'function' && typeof getFID === 'function' && 
          typeof getFCP === 'function' && typeof getLCP === 'function' && 
          typeof getTTFB === 'function') {
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
      } else {
        safeReportError('web_vitals_functions_unavailable', { version: webVitalsVersion });
      }
    }).catch((error) => {
      safeReportError('web_vitals_dynamic_import_failed');
    });
  }
};

export default reportWebVitals;
